import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'NTSCustomFilter',
    pure: false,
    standalone: true
})
export class NTSCustomFilterPipe implements PipeTransform {
  transform(value: any[], predicate: (item: any) => boolean): any[] {
    if (!value || value.length === 0 || !predicate) {
      return value;
    }
    return value.filter(predicate);
  }
}